<template>
  <div class="inv-root" data-aos="fade-right">
    <CrudToolbar title="Inventario" v-model="filtro" searchPlaceholder="Buscar por código o nombre...">
      <template #actions>
        <div class="filtro-wrapper" v-click-outside="cerrarFiltroPanel">
          <button
            class="btn-header btn-accion btn-filtro"
            type="button"
            @click="filtroPanelAbierto = !filtroPanelAbierto"
            title="Filtros"
          >
            <i class="bi" :class="totalFiltrosActivos > 0 ? 'bi-funnel-fill' : 'bi-funnel'"></i>
            <span class="btn-header-texto ms-2">Filtros</span>
            <span v-if="totalFiltrosActivos > 0" class="filtro-badge">{{ totalFiltrosActivos }}</span>
          </button>

          <div v-if="filtroPanelAbierto" class="filtro-backdrop" @click="cerrarFiltroPanel"></div>
          <div v-if="filtroPanelAbierto" class="filtro-panel">
            <div class="filtro-panel-header">
              <span>Filtros</span>
              <button
                type="button"
                class="filtro-limpiar"
                :disabled="totalFiltrosActivos === 0"
                @click="limpiarFiltros"
              >
                <i class="bi bi-x-circle"></i> Limpiar
              </button>
            </div>
            <div class="filtro-panel-body">
              <div v-for="campo in FILTRO_CAMPOS" :key="campo.field" class="filtro-grupo">
                <p class="filtro-grupo-titulo">{{ campo.label }}</p>
                <label v-for="op in opcionesFiltro(campo.field)" :key="op.value" class="filtro-item">
                  <input
                    type="checkbox"
                    :checked="filtrosColumnas[campo.field].has(op.value)"
                    @change="toggleFiltroValor(campo.field, op.value)"
                  />
                  <span class="filtro-item-label">{{ op.value }}</span>
                  <span class="filtro-item-count">{{ op.count }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn-header btn-accion btn-refrescar"
          type="button"
          :disabled="cargando"
          @click="cargar"
        >
          <span v-if="cargando" class="spinner-border spinner-border-sm"></span>
          <i v-else class="bi bi-arrow-clockwise"></i>
          <span class="btn-header-texto ms-2">Refrescar</span>
        </button>
      </template>
    </CrudToolbar>

    <div class="divisan-table-container shadow-lg">
      <Transition name="fade" mode="out-in">
        <div v-if="cargando" key="cargando" class="text-center py-5">
          <div class="spinner-border text-verde"></div>
        </div>
        <div v-else key="tabla">
          <div class="table-scroll">
            <table class="table table-divisan align-middle mb-0">
              <thead>
                <tr>
                  <th
                    v-for="col in COLUMNAS"
                    :key="col.field"
                    class="th-ordenable"
                    :class="col.thClass"
                    @click="ordenarPor(col.field)"
                  >
                    {{ col.label }}
                    <i
                      class="bi ms-1"
                      :class="
                        sortKey === col.field
                          ? sortDir === 'asc'
                            ? 'bi-arrow-up'
                            : 'bi-arrow-down'
                          : 'bi-arrow-down-up th-ordenable-hint'
                      "
                    ></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in paginados" :key="p.codigo" :class="{ 'fila-inactiva': !p.activo }">
                  <td class="ps-4 fw-bold text-cafe">{{ p.codigo }}</td>
                  <td>
                    <span class="text-cafe">{{ p.nombre }}</span>
                    <small v-if="p.modelo" class="d-block text-verde opacity-75">{{ p.modelo }}</small>
                  </td>
                  <td class="text-center fw-bold">{{ formatNum(p.stock_sistema) }}</td>
                  <td class="text-center">{{ formatNum(p.comprometido) }}</td>
                  <td class="text-center">{{ formatNum(p.disponible) }}</td>
                </tr>
                <tr v-if="paginados.length === 0">
                  <td colspan="5" class="text-center py-5 text-cafe opacity-50 fw-bold">
                    No se encontraron productos
                  </td>
                </tr>
              </tbody>
              <!-- Los totales suman todo lo filtrado, no solo la página visible -->
              <tfoot v-if="ordenados.length">
                <tr class="inv-fila-totales">
                  <td colspan="2" class="ps-4">Total ({{ ordenados.length }} productos)</td>
                  <td class="text-center">{{ formatNum(totalFisico) }}</td>
                  <td class="text-center">{{ formatNum(totalComprometido) }}</td>
                  <td class="text-center">{{ formatNum(totalDisponible) }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Paginación -->
          <div class="paginacion-wrapper">
            <div class="pag-izq">
              <small class="pag-info">{{ rangoInicio }}–{{ rangoFin }} de {{ ordenados.length }} productos</small>
              <div class="por-pagina-wrap">
                <label class="por-pagina-label">Filas:</label>
                <select
                  class="por-pagina-select"
                  :value="porPagina"
                  @change="cambiarPorPagina(Number($event.target.value))"
                >
                  <option v-for="n in paginacionStore.opcionesPorPagina" :key="n" :value="n">
                    {{ n }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pag-der">
              <button class="btn-pag" :disabled="paginaActual === 1" @click="paginaActual = 1" title="Primera">
                <i class="bi bi-chevron-double-left"></i>
              </button>
              <button class="btn-pag" :disabled="paginaActual === 1" @click="paginaActual--">
                <i class="bi bi-chevron-left"></i>
              </button>
              <template v-for="n in paginasVisibles" :key="n">
                <span v-if="n === '...'" class="pag-ellipsis">…</span>
                <button v-else :class="['btn-pag-num', { activo: n === paginaActual }]" @click="paginaActual = n">
                  {{ n }}
                </button>
              </template>
              <button class="btn-pag" :disabled="paginaActual === totalPaginas" @click="paginaActual++">
                <i class="bi bi-chevron-right"></i>
              </button>
              <button
                class="btn-pag"
                :disabled="paginaActual === totalPaginas"
                @click="paginaActual = totalPaginas"
                title="Última"
              >
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import Swal from "sweetalert2";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import { usePaginacionInventarioStore } from "@/store/paginacionStore";
import { getCatalogoProductosCompleto } from "@/utils/api_backend";

// Tabla de consulta (no CRUD), con el mismo patrón que Productos:
// buscador, embudo de filtros, encabezados ordenables y paginación.
// 'comprometido' todavía no tiene flujo que lo alimente (llega con las
// salidas por pedido), así que por ahora disponible == inventario físico.
const paginacionStore = usePaginacionInventarioStore();

const filtro = ref("");
const cargando = ref(false);
const productos = ref([]);
const paginaActual = ref(1);

const COLUMNAS = [
  { field: "codigo", label: "Código", thClass: "ps-4" },
  { field: "nombre", label: "Producto / Modelo" },
  { field: "stock_sistema", label: "Inventario físico", thClass: "text-center" },
  { field: "comprometido", label: "Comprometido", thClass: "text-center" },
  { field: "disponible", label: "Disponible", thClass: "text-center" },
];
const CAMPOS_NUMERICOS = new Set(["stock_sistema", "comprometido", "disponible"]);

// ── Ordenamiento ─────────────────────────────────────────────
const sortKey = ref("codigo");
const sortDir = ref("asc");
function ordenarPor(field) {
  sortDir.value = sortKey.value === field && sortDir.value === "asc" ? "desc" : "asc";
  sortKey.value = field;
  paginaActual.value = 1;
}

// ── Filtros (embudo) ─────────────────────────────────────────
const FILTRO_CAMPOS = [
  { field: "tipo", label: "Tipo" },
  { field: "color_nombre", label: "Color" },
  { field: "existencia", label: "Existencia" },
  { field: "activo", label: "Activo" },
];
const ETIQUETAS_TIPO = { FABRICACION: "Fabricación", IMPORTACION: "Importación" };

function valorFiltro(field, item) {
  if (field === "tipo") return ETIQUETAS_TIPO[item.tipo] || "Sin especificar";
  if (field === "activo") return item.activo ? "Sí" : "No";
  if (field === "existencia") {
    const n = Number(item.stock_sistema) || 0;
    if (n > 0) return "Con existencia";
    return n < 0 ? "Negativo" : "Sin existencia";
  }
  const v = item[field];
  return v === null || v === undefined || v === "" ? "—" : String(v);
}
function opcionesFiltro(field) {
  const counts = new Map();
  for (const item of productos.value) {
    const v = valorFiltro(field, item);
    counts.set(v, (counts.get(v) || 0) + 1);
  }
  return [...counts.entries()]
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => a.value.localeCompare(b.value, "es", { numeric: true }));
}
const filtrosColumnas = ref(Object.fromEntries(FILTRO_CAMPOS.map((c) => [c.field, new Set()])));
const filtroPanelAbierto = ref(false);
const totalFiltrosActivos = computed(
  () => Object.values(filtrosColumnas.value).filter((s) => s.size > 0).length
);
function toggleFiltroValor(field, value) {
  const set = new Set(filtrosColumnas.value[field]);
  if (set.has(value)) set.delete(value);
  else set.add(value);
  filtrosColumnas.value = { ...filtrosColumnas.value, [field]: set };
  paginaActual.value = 1;
}
function limpiarFiltros() {
  filtrosColumnas.value = Object.fromEntries(FILTRO_CAMPOS.map((c) => [c.field, new Set()]));
  paginaActual.value = 1;
}
function cerrarFiltroPanel() {
  filtroPanelAbierto.value = false;
}
// Cierra el panel de filtros al hacer clic fuera (igual que en Productos)
const vClickOutside = {
  mounted(el, b) {
    el._co = (e) => {
      if (!el.contains(e.target)) b.value(e);
    };
    document.addEventListener("click", el._co);
  },
  unmounted(el) {
    document.removeEventListener("click", el._co);
  },
};

watch(filtro, () => {
  paginaActual.value = 1;
});

// ── Filtrado, orden y paginación ─────────────────────────────
const filtrados = computed(() => {
  const s = filtro.value.trim().toLowerCase();
  return productos.value.filter((p) => {
    const coincide =
      !s ||
      p.codigo.toLowerCase().includes(s) ||
      p.nombre.toLowerCase().includes(s) ||
      (p.modelo || "").toLowerCase().includes(s);
    if (!coincide) return false;
    for (const { field } of FILTRO_CAMPOS) {
      const set = filtrosColumnas.value[field];
      if (set.size > 0 && !set.has(valorFiltro(field, p))) return false;
    }
    return true;
  });
});

const ordenados = computed(() => {
  const key = sortKey.value;
  const signo = sortDir.value === "asc" ? 1 : -1;
  return [...filtrados.value].sort((a, b) => {
    const cmp = CAMPOS_NUMERICOS.has(key)
      ? (Number(a[key]) || 0) - (Number(b[key]) || 0)
      : String(a[key] ?? "").localeCompare(String(b[key] ?? ""), "es", {
          sensitivity: "base",
          numeric: true,
        });
    return cmp * signo;
  });
});

const porPagina = computed(() => paginacionStore.porPagina);
const totalPaginas = computed(() => Math.max(1, Math.ceil(ordenados.value.length / porPagina.value)));
const paginados = computed(() => {
  const inicio = (paginaActual.value - 1) * porPagina.value;
  return ordenados.value.slice(inicio, inicio + porPagina.value);
});
const rangoInicio = computed(() =>
  ordenados.value.length === 0 ? 0 : (paginaActual.value - 1) * porPagina.value + 1
);
const rangoFin = computed(() => Math.min(paginaActual.value * porPagina.value, ordenados.value.length));
const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});
function cambiarPorPagina(n) {
  paginacionStore.setPorPagina(n);
  paginaActual.value = 1;
}
// Si al refrescar o filtrar quedan menos páginas, no quedarse en una vacía.
watch(totalPaginas, (total) => {
  if (paginaActual.value > total) paginaActual.value = total;
});

const totalFisico = computed(() => ordenados.value.reduce((s, p) => s + (p.stock_sistema || 0), 0));
const totalComprometido = computed(() => ordenados.value.reduce((s, p) => s + (p.comprometido || 0), 0));
const totalDisponible = computed(() => ordenados.value.reduce((s, p) => s + (p.disponible || 0), 0));

async function cargar() {
  cargando.value = true;
  try {
    productos.value = await getCatalogoProductosCompleto();
  } catch {
    Swal.fire("Error", "No se pudo cargar el inventario", "error");
  } finally {
    cargando.value = false;
  }
}

function formatNum(v) {
  return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(v ?? 0);
}

onMounted(cargar);
</script>

<style scoped>
.inv-root {
  padding: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: var(--d-radius-lg);
  box-shadow: var(--d-elevation-2);
  overflow: hidden;
}
.table-scroll {
  overflow-x: auto;
}
.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 1px solid var(--d-border);
}
.table-divisan th {
  padding: 15px;
  font-weight: 800;
  text-transform: capitalize;
  border: none;
  white-space: nowrap;
}
.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 12px 15px;
  white-space: nowrap;
}
.table-divisan tbody tr:hover td {
  background-color: rgba(96, 108, 56, 0.05);
}
.fila-inactiva td {
  opacity: 0.55;
}
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}
.inv-fila-totales td {
  background: rgba(96, 108, 56, 0.08);
  font-weight: 800;
  color: var(--d-brown);
  border-bottom: none;
}

/* ── Encabezados ordenables (mismo estilo que Productos) ── */
.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: color 0.15s;
}
.th-ordenable:hover {
  color: var(--d-green);
}
.th-ordenable i {
  font-size: 0.7rem;
  color: var(--d-green);
}
.th-ordenable-hint {
  opacity: 0.35;
  transition: opacity 0.15s;
}
.th-ordenable:hover .th-ordenable-hint {
  opacity: 0.8;
}

/* ── Botones del toolbar ── */
.btn-accion {
  border-radius: var(--d-radius-pill);
  padding: 7px 16px;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s;
}
.btn-accion:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-header {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-refrescar {
  background: var(--d-green);
  border: 1.5px solid var(--d-green);
  color: white;
}
.btn-refrescar:hover:not(:disabled) {
  background: var(--d-green-dark);
}
@media (max-width: 575.98px) {
  .btn-header-texto {
    display: none;
  }
}

/* ── Panel de filtros (embudo), igual que en Productos ── */
.filtro-wrapper {
  position: relative;
}
.btn-filtro {
  background: white;
  border: 1.5px solid rgba(64, 34, 8, 0.3);
  color: var(--d-brown);
  position: relative;
}
.btn-filtro:hover {
  background: rgba(64, 34, 8, 0.06);
}
.filtro-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  margin-left: 6px;
  border-radius: 999px;
  background: var(--d-green);
  color: white;
  font-size: 0.65rem;
  font-weight: 800;
}
.filtro-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1090;
  width: 280px;
  max-height: 420px;
  display: flex;
  flex-direction: column;
  background: white;
  border: 1.5px solid var(--d-green);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(40, 54, 24, 0.2);
}
.filtro-backdrop {
  display: none;
}
@media (max-width: 767.98px) {
  .filtro-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1089;
    background: rgba(20, 30, 40, 0.45);
  }
  .filtro-panel {
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    width: min(90vw, 320px);
    max-height: 80vh;
  }
}
.filtro-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--d-border);
  font-weight: 800;
  color: var(--d-brown);
  font-size: 0.85rem;
}
.filtro-limpiar {
  border: none;
  background: transparent;
  color: var(--d-brown);
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.filtro-limpiar:disabled {
  opacity: 0.35;
  cursor: default;
}
.filtro-panel-body {
  overflow-y: auto;
  padding: 6px 4px;
}
.filtro-grupo {
  padding: 6px 10px;
  border-bottom: 1px solid rgba(64, 34, 8, 0.08);
}
.filtro-grupo:last-child {
  border-bottom: none;
}
.filtro-grupo-titulo {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--d-green);
}
.filtro-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 4px;
  border-radius: 6px;
  font-size: 0.8rem;
  color: var(--d-brown);
  cursor: pointer;
}
.filtro-item:hover {
  background: rgba(96, 108, 56, 0.08);
}
.filtro-item-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filtro-item-count {
  color: var(--d-text-muted, rgba(64, 34, 8, 0.5));
  font-size: 0.7rem;
}

/* ── Paginación, igual que en Productos ── */
.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  min-width: 58px;
}
.por-pagina-select:focus,
.por-pagina-select:hover {
  border-color: var(--d-brown);
}
.btn-pag {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.35);
  color: var(--d-brown);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.8rem;
}
.btn-pag:hover:not(:disabled) {
  background: var(--d-green);
  color: var(--d-cream);
  border-color: var(--d-green);
}
.btn-pag:disabled {
  opacity: 0.3;
  cursor: default;
}
.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}
</style>
